import { render, staticRenderFns } from "./LegalRules.vue?vue&type=template&id=4634fee1&scoped=true"
import script from "./LegalRules.vue?vue&type=script&lang=ts"
export * from "./LegalRules.vue?vue&type=script&lang=ts"
import style0 from "./LegalRules.vue?vue&type=style&index=0&id=4634fee1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634fee1",
  null
  
)

export default component.exports